import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import "./App.scss";
import { initAnalytics, trackPageView } from "./utils/analytics";
import LeaderboardProvider from "./provider/leaderboard";
import "react-toastify/dist/ReactToastify.css";
// Pages
import LeaderBoard from "./pages/leaderboard";
import NavBar2 from "./components/NavBar2/NavBar2";
import FortuneTabBar from "./components/FortuneTabBar/FortuneTabBar";
import WalletGateOverlay from "./components/WalletGateOverlay/WalletGateOverlay";
import ProfileGateOverlay from "./components/ProfileGateOverlay/ProfileGateOverlay";
import Error from "./pages/ErrorPage/Error";
// import Profile from "./components/profile/index";
import DiscordLoading from "./pages/discordLoading";
import TwitterLoading from "./pages/twitterLoading";
import UserProvider from "./provider/userprovider";
import { WagmiProvider } from "wagmi";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { wagmiAdapter } from "./config/reownAppKit";

const queryClient = new QueryClient();

function App() {
  const location = useLocation();

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    trackPageView(`${location.pathname}${location.search}${location.hash}`);
  }, [location.pathname, location.search, location.hash]);
  return (
    <WagmiProvider config={wagmiAdapter.wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <UserProvider>
          <LeaderboardProvider>
            <ToastContainer />
            <NavBar2 />
            <WalletGateOverlay />
            <ProfileGateOverlay />
            <Routes>
              <Route path="/" element={<LeaderBoard />} />
              <Route path="/*" element={<Error />} />
            </Routes>
            {location.pathname === "/" ? <FortuneTabBar /> : null}
          </LeaderboardProvider>
        </UserProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}

export default App;
